var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.92188 18.6641C7.49471 18.6641 7.12404 18.5069 6.80988 18.1926C6.49554 17.8784 6.33838 17.5077 6.33838 17.0806V3.74731C6.33838 3.32015 6.49554 2.94948 6.80988 2.63531C7.12404 2.32115 7.49471 2.16406 7.92188 2.16406H18.2551C18.6823 2.16406 19.053 2.32115 19.3671 2.63531C19.6813 2.94948 19.8384 3.32015 19.8384 3.74731V17.0806C19.8384 17.5077 19.6813 17.8784 19.3671 18.1926C19.053 18.5069 18.6823 18.6641 18.2551 18.6641H7.92188ZM7.92188 17.0806H18.2551V3.74731H7.92188V17.0806ZM4.75513 21.8306C4.32796 21.8306 3.95729 21.6735 3.64313 21.3593C3.32896 21.0451 3.17188 20.6745 3.17188 20.2473V6.11806C3.17188 5.90223 3.24921 5.71706 3.40387 5.56256C3.55854 5.4079 3.74604 5.33056 3.96638 5.33056C4.18671 5.33056 4.37321 5.4079 4.52588 5.56256C4.67871 5.71706 4.75513 5.90223 4.75513 6.11806V20.2473H15.8844C16.1002 20.2473 16.2854 20.3249 16.4399 20.4801C16.5945 20.6352 16.6719 20.8211 16.6719 21.0378C16.6719 21.2608 16.5945 21.4487 16.4399 21.6016C16.2854 21.7542 16.1002 21.8306 15.8844 21.8306H4.75513Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.4d5c5370c2badfa4ec723dc01d989ec5.svg";
export { ForwardRef as ReactComponent };